'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const client = require('./client');

import Avatar from 'material-ui/Avatar';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';

import {
	  Table,
	  TableBody,
	  TableHeader,
	  TableHeaderColumn,
	  TableRow,
	  TableRowColumn,
	} from 'material-ui/Table';

export default class TableauNav extends React.Component {
	
	constructor(props) {
		super(props);
	
		this.state = {
			dossierInstance:"",
			itemValue: 105,
			viewValue: "",
			items: []
	    };
		this.mTable ={};
		this.currentView = 0;
		
		this.changeFilter = this.changeFilter.bind(this);
		this.changeView = this.changeView.bind(this);
		this.changeViewTable = this.changeViewTable.bind(this);
		this.updateFilterElements = this.updateFilterElements.bind(this);
		
		this.items = [];
		for (let i = 100; i < 116; i++ ) {
		  this.items.push(<MenuItem value={i} key={i} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Store ' +i } />);
		}
		
		this.views = [];
		this.views.push(<MenuItem value={"Overview"} key={1} primaryText={"Overview"} />);
		this.views.push(<MenuItem value={"Sales"} key={2} primaryText={"Sales"} />);
		this.views.push(<MenuItem value={"Service"} key={3} primaryText={"Service"} />);
	}
	
	updateFilterElements(items){
		var newItems = [];
		Object.keys(items).forEach(function (entry){
			var ltest = "";
			ltest= <MenuItem value={parseInt(entry)} key={parseInt(entry)} style={{color: 'white', backgroundColor: '#424448'}} primaryText={'Store ' +entry } />;
			newItems.push(ltest);
		}); 
		
		this.setState({itemValue:parseInt(Object.keys(items)[0]) , items: newItems});
	}
	
	changeFilter(e, index, selection){
		this.setState({itemValue: selection});
		this.props.app.mTableauEmbedded.changeFilter(selection);
	}
	
	changeView(e, index, selection) {
		this.setState({viewValue: selection});
		this.props.app.mTableauEmbedded.changeViz(selection);
	}
	
	changeViewTable(e, index, selection) {
		if(e[0] != this.currentView){
			var lTest = 0;
			this.currentView = e[0];
			if(e[0] == 0){
				this.props.app.mTableauEmbedded.changeViz("Overview");
			}else if (e[0] == 1){
				this.props.app.mTableauEmbedded.changeViz("Sales");
			}else{
				this.props.app.mTableauEmbedded.changeViz("Service");
			}
			this.setState({viewValue: e[0]})
		}
	}
	
	componentDidUpdate() {

	}

	componentDidMount() {
		
        
	}
	
	render() {
		return (
				<div className="tableauNav" style={{fontSize: "16px", backgroundColor:"#0f1924", textAlign: "center", height:"100vh", minHeight:"800px"}} >
				  <Row style={{marginBottom: "33px"}}>
				  	<img src={"./img/TabXMLogo.png"} height= "20px" style={{textAlign: "center", marginTop: "15px", height: "50%", width: "50%"}} />
				  </Row>
				  <Row style={{marginBottom: "0px"}}>
				  	<img src={"./img/"+this.props.img} height= "100px" style={{textAlign: "center"}} />
				  </Row>
				  <Row style={{marginBottom: "0px"}}>
				  	<div style={{color: "white", marginBottom: "0px"}}>{this.props.fulluser}</div>
				  </Row>
				  <Row style={{marginBottom: "32px"}}>
				  	<div style={{color: "#1e9fd6"}}>{this.props.role}</div>
				  </Row>
				  <Row style={{marginBottom: "5px"}}>
				  	<div style={{color: "white"}}>RESTAURANT:</div>
				  </Row>
				  <Row style={{marginBottom: "10px"}}>
					  <SelectField className ="custom-selectfield" dropDownMenuProps={{
						  				anchorOrigin:{ vertical: 'bottom', horizontal: 'left'},
					  					style: {color:'white'},
					  					height:'25px',
					  					menuStyle: {padding: '0px'}
					  				}} 
					  		value={this.state.itemValue} 
					  		underlineStyle={{display:'none'}}
		                    style={{backgroundColor:'#42444c', 
		                    		color:'white',
		                    		borderRadius:'25px',
		                    		height:'25px',
		                    		width: '65%'
		                          }}
					  		selectedMenuItemStyle={{color:'#1e9fd6'
	                          }}
					  		labelStyle={{color:'white'
	                          }}
							listStyle={{color:'white'
		                      }}
					  		onChange={this.changeFilter} maxHeight={200}>
					  		
				        {this.state.items}
				      </SelectField>
				  </Row>
				  <Row style={{marginBottom: "5px"}}>
				  	<div style={{color: "white"}}>NAVIGATION</div>	
				  </Row>
				  <Table ref={(c) => this.mTable = c}  onRowSelection= {this.changeViewTable}>
				    <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
				      <TableRow className={this.currentView==0?"selected":"unselected"} selected={this.currentView==0?true:false} displayBorder={false} 
				      		style={{cursor: "pointer", color: "white", backgroundColor:this.currentView==0?"#1e9fd6":"#0f1924"}}>
				        <TableRowColumn style={{fontSize: "16px", textAlign: "center", borderTop: "1px solid #999", color: "white", backgroundColor:this.currentView==0?"#1e9fd6":"#0f1924"}}>Overview</TableRowColumn>
				      </TableRow>
				      <TableRow className={this.currentView==1?"selected":"unselected"} selected={this.currentView==1?true:false} displayBorder={false} 
				      		style={{cursor: "pointer", color: "white", backgroundColor:this.currentView==1?"#1e9fd6":"#0f1924"}}>
				        <TableRowColumn style={{fontSize: "16px", textAlign: "center", borderTop: "1px solid #999", color: "white", backgroundColor:this.currentView==1?"#1e9fd6":"#0f1924"}}>Sales</TableRowColumn>
				      </TableRow>
				      <TableRow className={this.currentView==2?"selected":"unselected"} selected={this.currentView==2?true:false} displayBorder={false} 
				      		style={{cursor: "pointer", color: "white", backgroundColor:this.currentView==2?"#1e9fd6":"#0f1924"}}>
				        <TableRowColumn style={{fontSize: "16px", textAlign: "center", borderTop: "1px solid #999", color: "white", backgroundColor:this.currentView==2?"#1e9fd6":"#0f1924"}}>Service</TableRowColumn>
				      </TableRow>
				    </TableBody>
				  </Table>
				  <Row style={{position: "absolute", bottom: "0"}}>
				  	<img src={"./img/TabHeader.png"} height= "60px" style={{textAlign: "center", marginTop: "15px", height: "40%", width: "40%"}} />
				  </Row>
			  	</div>
			)
	}
}


// WEBPACK FOOTER //
// ./src/main/js/TableauNav.js